<!-- filepath: /Users/desarrollo/Documents/Proyectos/friax/src/views/Home.vue -->
<template>
  <div class="content-custom">
    <carrouselTerranova />
    <!-- Conocer -->
    <div class="d-flex justify-content-center">
      <div class=" col-10 row divConocer">
        <div class="col-12 col-xl-6 col-lg-6 d-flex align-items-center ">
          <div data-animation="IzqADer" class=" ml20Porcent bg-white divText">
            <img src="../../public/assets/images/logos/LogoTerranovaAzul.png" class="imgConocer1" alt="...">
            <div class="divConocerContenedor1 bb-2 bb-primary mb10 pb10 w-full">
              <p class="titulo ">conoce terranova</p>
            </div>
            <p class="titulo">Terrenos desde $355,000</p>
            <p class="message mx-auto ">Terranova es un <b>desarrollo privado</b> con terrenos y casas de calidad,
              <b>servicios completos</b> y una <b>ubicación privilegiada</b> al norte de la ciudad, diseñado para
              brindarte
              estabilidad y un futuro seguro. Además contamos con <b>facilidades de pago</b>, incluyendo la opción de
              adquirir
              tu lote a través de <b>créditos INFONAVIT</b>.
            </p>
          </div>
        </div>
        <div data-animation="FadeInRight" class="col-12 col-xl-6 col-lg-6 text-lg-center h500">
          <img v-if="screenWidth > 600" src="../../public/assets/images/terranova/Terranova_Img1.png" class="imgConocer"
            alt="...">
          <img v-else src="../../public/assets/images/movil/terranova/Terranova_Img1.png.png" class="imgConocer"
            alt="...">
        </div>
      </div>
    </div>
    <!-- Infonavit -->
    <div class="d-flex justify-content-center bg-image text-white">
      <div data-animation="FadeIn" class="divInfonavit mx-auto">
        <img src="../../public/assets/images/terranova/LogoInfonavitBlanco.png" class="imgInfonavit mx-auto" alt="...">
        <p class="titulo">¡Aceptamos crédito Infonavit!</p>
        <p class="mx-auto subtitulo">¿Necesitas apoyo para la consulta de tu pre-calificación?</p>
        <p class="mx-auto subtitulo2">¡No dudes en contactarnos! En FRIAX te asesoramos y acompañamos como
          <b>constructora
            autorizada</b>
          por INFONAVIT.
        </p>
        <div>
          <button type="button" @click="() => $router.push('/contacto')"
            class="btn btn-primary4 btn-rounded text-uppercase mx-auto">Contáctanos</button>
        </div>
      </div>
    </div>
    <!-- Mapa -->
    <div class="d-flex justify-content-center">
      <div class="divMapaContenedor">
        <div data-animation="IzqADer" class="">
          <div class=" divMapaTexto ml20Porcent bg-white">
            <div class="divMapaTextoContenedor1 mb10 pb10 w-full">
              <p class="titulo">Brindando confianza y calidad</p>
            </div>
            <p class="titulo">Lotes residenciales desde 125m<sup>2</sup>
              hasta 195m<sup>2</sup></p>
            <p class="subtitulo">Ofrecemos terrenos y casas de <b>alta calidad</b> en un <b>fraccionamiento
                privado</b>, asegurando todos los <b>servicios</b> necesarios y una <b>ubicación</b> estratégica.
            </p>
          </div>
        </div>
        <div data-animation="FadeInRight" class="col-12 col-xl-8 col-lg-8 d-flex align-items-center px-md-5">
          <img :src="getImageUrl('assets/images/terranova/Terranova_Lotificacion.png')" class="img-fluid p-0" alt="...">
        </div>
      </div>
    </div>
    <!-- Beneficios -->
    <div class="d-flex justify-content-center bg-primary">
      <div data-animation="FadeIn" class="col-10 mx-auto text-white my75">
        <div class="col-12 row ">
          <p class="mx-auto divBeneficiosTitulo ">Beneficios de Terranova</p>
        </div>

        <div v-if="screenWidth > 600" class="w-full">
          <div class="col-12 row justify-content-between">
            <cardBeneficio v-for="item in beneficios" :key="item.id" :item="item" class="col-12 col-md-2" />
          </div>
          <div class=" col-12 row justify-content-between ">
            <div class=" col-12 row justify-content-between">
              <cardBeneficio v-for="item in beneficios2" :key="item.id" :item="item" class="col-12 col-md-3" />
            </div>
          </div>
        </div>

        <div v-else class="divBeneficiosContenedor row mx-auto justify-content-center">
          <cardBeneficio v-for="(item, index) in beneficiosMovil" :key="item.id" :item="item" class="divItemBeneficios"
            :class="index == 1 ? ' w140 ' : ' w90 '" />
        </div>
      </div>
    </div>
    <!-- Ubicacion -->
    <div class="d-flex justify-content-center">
      <div class=" mx-auto divUbicacion">
        <p data-animation="FadeIn" class="col-12 font32 fw-bold lh120Porcent text-uppercase text-primary text-center">
          Ubicación estratégica</p>
        <div class="col-12 col-xl-10 col-lg-10 mx-auto">
          <img src="../../public/assets/images/terranova/Terranova_MapaUbicacion.png" class="img-fluid p-0" alt="...">
        </div>
      </div>
    </div>
    <!-- Preguntas -->
    <div class="d-flex justify-content-center bg-gray">
      <div class=" col-11 col-xl-8 col-lg-8 mx-auto row my90">
        <p class="mb75 font32 text-center fw-bold lh120Porcent text-uppercase text-primary">Preguntas frecuentes</p>
        <preguntasFrecuentes class="col-12 mb-2" v-for="item in preguntas" :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import carrouselTerranova from '../components/home/carrouselTerranova.vue';
import preguntasFrecuentes from '../components/preguntasFrecuentes.vue';
import cardBeneficio from '../components/beneficios.vue';
import { inject } from 'vue';
export default {
  name: 'Home',
  components: {
    carrouselTerranova,
    cardBeneficio,
    preguntasFrecuentes
  },
  setup() {
    const screenWidth = inject('screenWidth');
    return {
      screenWidth
    }
  },
  data() {
    return {
      beneficios: [
        {
          id: 1,
          img: 'assets/images/icons/1-Escuelas.svg',
          text: 'A 4 minutos de escuelas'
        },
        {
          id: 2,
          img: 'assets/images/icons/2-Supermercados.svg',
          text: 'A 10 minutos de supermercados'
        },
        {
          id: 3,
          img: 'assets/images/icons/3-ReglamentoInterno.svg',
          text: 'Reglamento interno'
        },
        {
          id: 4,
          img: 'assets/images/icons/4-AsociacionVecinos.svg',
          text: 'Asociación de vecinos'
        },
        {
          id: 5,
          img: 'assets/images/icons/5-CasetaVigilancia.svg',
          text: 'Caseta de vigilancia'
        },
      ],
      beneficios2: [
        {
          id: 1,
          img: 'assets/images/icons/6-Luz.svg',
          text: 'Luz'
        },
        {
          id: 2,
          img: 'assets/images/icons/7-Agua.svg',
          text: 'Agua'
        },
        {
          id: 3,
          img: 'assets/images/icons/8-Drenaje.svg',
          text: 'Drenaje'
        },
        {
          id: 4,
          img: 'assets/images/icons/9-AreasVerdes.svg',
          text: 'Areas verdes'
        },
      ],

      beneficiosMovil: [
        {
          id: 1,
          img: 'assets/images/icons/1-Escuelas.svg',
          text: 'A 4 minutos de escuelas'
        },
        {
          id: 2,
          img: 'assets/images/icons/2-Supermercados.svg',
          text: 'A 10 minutos de supermercados'
        },
        {
          id: 3,
          img: 'assets/images/icons/3-ReglamentoInterno.svg',
          text: 'Reglamento interno'
        },
        {
          id: 4,
          img: 'assets/images/icons/4-AsociacionVecinos.svg',
          text: 'Asociación de vecinos'
        },
        {
          id: 5,
          img: 'assets/images/icons/5-CasetaVigilancia.svg',
          text: 'Caseta de vigilancia'
        },
        {
          id: 1,
          img: 'assets/images/icons/6-Luz.svg',
          text: 'Luz'
        },
        {
          id: 2,
          img: 'assets/images/icons/7-Agua.svg',
          text: 'Agua'
        },
        {
          id: 3,
          img: 'assets/images/icons/8-Drenaje.svg',
          text: 'Drenaje'
        },
        {
          id: 4,
          img: 'assets/images/icons/9-AreasVerdes.svg',
          text: 'Areas verdes'
        },
      ],
      preguntas: [
        {
          id: 1,
          pregunta: '¿Qué es Terranova?',
          respuesta: 'Terranova es un desarrollo privado con terrenos y casas de calidad, servicios completos y una ubicación privilegiada al norte de la ciudad, diseñado para brindarte estabilidad y un futuro seguro. Además contamos con facilidades de pago, incluyendo la opción de adquirir tu lote a través de créditos INFONAVIT.'
        },
        {
          id: 2,
          pregunta: '¿Cómo puedo obtener mi precalificación de Infonavit?',
          respuesta: 'Terranova es un desarrollo privado con terrenos y casas de calidad, servicios completos y una ubicación privilegiada al norte de la ciudad, diseñado para brindarte estabilidad y un futuro seguro. Además contamos con facilidades de pago, incluyendo la opción de adquirir tu lote a través de créditos INFONAVIT.'
        },
        {
          id: 3,
          pregunta: '¿Cuáles son los costos de mantenimiento en Terranova?',
          respuesta: 'Los costos de mantenimiento en Terranova dependen de la administración encargada, aunque en promedio se estima un costo mensual entre $300 y $500.'
        },
        {
          id: 4,
          pregunta: '¿Cuál es el precio de los lotes en Terranova?',
          respuesta: 'Los precios de los lotes en Terranova varían según su ubicación y tamaño, comenzando desde $335,000.'
        },
        {
          id: 5,
          pregunta: '¿Qué superficie tienen los terrenos en Terranova?',
          respuesta: 'En Terranova, ofrecemos lotes con superficies que van desde los 125 m² hasta los 195 m².'
        },
        {
          id: 6,
          pregunta: '¿Venderán casas en Terranova?',
          respuesta: 'Sí, en Terranova tendremos casas disponibles para la venta. Actualmente, contamos con un modelo listo para que lo conozcas.'
        },
        {
          id: 7,
          pregunta: '¿Qué precios tienen las casas en Terranova?',
          respuesta: 'Los precios de las casas en Terranova comienzan desde $690,000 y ofrecen una superficie de 38.5 m² de construcción.'
        },
        {
          id: 8,
          pregunta: '¿Cómo puedo apartar mi terreno o casa en Terranova?',
          respuesta: 'Para apartar tu terreno o casa en Terranova, es necesario realizar un pago de $10,000, destinado a la asociación civil que gestiona el mantenimiento del fraccionamiento.'
        },
        {
          id: 9,
          pregunta: '¿Terranova es un fraccionamiento privado?',
          respuesta: 'Sí, Terranova es un fraccionamiento tipo condominio que contará con áreas jardinadas privadas, acceso controlado y vigilancia para la seguridad y comodidad de sus residentes.'
        },
      ]
    }
  },
  methods: {
    getImageUrl(imgPath) {
      return `${window.location.origin}/${imgPath}`;
    }
  }
}
</script>
<style scoped>
.bg-image {

  background-image: url("../../public/assets/images/terranova/Terranova_BannerInfonavit.png");
  /* Cambia esta ruta a la de tu imagen */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.divBeneficio {
  width: 20% !important;
}

.divBeneficio2 {
  width: 25% !important;
}
</style>
